<template>
  <div id="tribeId">
    <div class="d-flex justify-content-center">
      <div class="padding">
        <div class="row">
          <div class="col-12">
            <h2>Why TribeID</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 content text">
            <p>
              Thousands of initiatives, some private, others
              public, exist today throughout Africa with the
              objective of boosting the capacity of Africa’s
              SMEs (including “startups”).
            </p>
            <p>
              Many of these programs target a range of
              well-understood SME limitations across the
              continent: market access, access to capital,
              branding and marketing, compliance,
              formalisation and talent.
            </p>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 content">
            <img src="../assets/man.jpg" class="img-fluid" alt />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 content">
            <img src="../assets/ship.jpg" class="img-fluid" alt />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 content text">
            <p>
              But there are few programs that focus
              specifically on cross-border operating capacity
              without the presumption that these various other
              dimensions need to be addressed first.
            </p>
            <p>
              TribeID is designed to operate within the
              current limitations and in spite of the
              widespread bottlenecks in the way of SME
              regional export readiness. In some ways, these
              limitations are the very fuel that fires its
              relevance and justifies its importance to
              AfCFTA.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .content{
    margin-top:30px;
  }
 
</style>